class ProductAddonsCarousel {
  constructor() {
    this.carousel = document.querySelector('.product-addons-carousel');
    if (!this.carousel) return;
    
    this.track = this.carousel.querySelector('.addons-carousel-track');
    this.cards = this.carousel.querySelectorAll('.addon-product-card');
    this.prevBtn = this.carousel.querySelector('.carousel-nav-prev');
    this.nextBtn = this.carousel.querySelector('.carousel-nav-next');
    this.dotsContainer = this.carousel.querySelector('.carousel-dots');
    
    this.currentIndex = 0;
    this.cardsPerView = this.getCardsPerView();
    this.maxIndex = Math.max(0, this.cards.length - this.cardsPerView);
    
    this.init();
  }
  
  init() {
    if (this.cards.length === 0) return;
    
    this.createDots();
    this.updateCarousel();
    this.bindEvents();
    this.handleResize();
    this.initAddToCart();
  }
  
  getCardsPerView() {
    const width = window.innerWidth;
    if (width < 900) return 1;
    if (width < 1600) return 2;
    return 3;
  }
  
  createDots() {
    const totalDots = Math.ceil(this.cards.length / this.cardsPerView);
    
    for (let i = 0; i < totalDots; i++) {
      const dot = document.createElement('button');
      dot.className = 'carousel-dot';
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => this.goToSlide(i));
      this.dotsContainer.appendChild(dot);
    }
  }
  
  updateCarousel() {
    // Calculate transform based on current index
    const cardWidth = this.cards[0].offsetWidth;
    const gap = 30; // Match CSS gap
    const translateX = -(this.currentIndex * (cardWidth + gap));
    
    this.track.style.transform = `translateX(${translateX}px)`;
    
    // Update navigation buttons
    this.prevBtn.disabled = this.currentIndex === 0;
    this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
    
    // Update dots
    const dots = this.dotsContainer.querySelectorAll('.carousel-dot');
    const activeDotIndex = Math.floor(this.currentIndex / this.cardsPerView);
    
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === activeDotIndex);
    });
  }
  
  goToSlide(dotIndex) {
    this.currentIndex = dotIndex * this.cardsPerView;
    this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
    this.updateCarousel();
  }
  
  nextSlide() {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex = Math.min(this.currentIndex + this.cardsPerView, this.maxIndex);
      this.updateCarousel();
    }
  }
  
  prevSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex = Math.max(this.currentIndex - this.cardsPerView, 0);
      this.updateCarousel();
    }
  }
  
  bindEvents() {
    this.prevBtn.addEventListener('click', () => this.prevSlide());
    this.nextBtn.addEventListener('click', () => this.nextSlide());
    
    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;
    
    this.track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });
    
    this.track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    });
  }
  
  handleSwipe(startX, endX) {
    const swipeThreshold = 50;
    const diff = startX - endX;
    
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        this.nextSlide();
      } else {
        this.prevSlide();
      }
    }
  }
  
  handleResize() {
    let resizeTimer;
    
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const newCardsPerView = this.getCardsPerView();
        
        if (newCardsPerView !== this.cardsPerView) {
          this.cardsPerView = newCardsPerView;
          this.maxIndex = Math.max(0, this.cards.length - this.cardsPerView);
          this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
          
          // Recreate dots
          this.dotsContainer.innerHTML = '';
          this.createDots();
          
          this.updateCarousel();
        }
      }, 250);
    });
  }
  
  initAddToCart() {
    const forms = this.carousel.querySelectorAll('.addon-add-to-cart-form');
    
    forms.forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        const button = form.querySelector('.addon-add-to-cart-btn');
        const originalText = button.textContent;
        
        button.textContent = 'Adding...';
        button.disabled = true;
        
        try {
          const formData = new FormData(form);
          
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          
          if (response.ok) {
            button.textContent = 'Added!';
            
            // Trigger cart update event
            document.dispatchEvent(new CustomEvent('cart:updated'));
            
            // Update floating cart if it exists
            if (window.FloatingAddToCart) {
              window.FloatingAddToCart.updateCart();
            }
            
            setTimeout(() => {
              button.textContent = originalText;
              button.disabled = false;
            }, 2000);
          } else {
            throw new Error('Failed to add to cart');
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          button.textContent = 'Error';
          
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);
        }
      });
    });
    
    // Wishlist functionality
    const wishlistBtns = this.carousel.querySelectorAll('.addon-wishlist-btn');
    
    wishlistBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        btn.classList.toggle('active');
        
        // Here you would integrate with your wishlist system
        const productTitle = btn.getAttribute('aria-label').replace('Add ', '').replace(' to wishlist', '');
        console.log('Wishlist toggle for:', productTitle);
      });
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductAddonsCarousel();
  });
} else {
  new ProductAddonsCarousel();
}
